// extracted by mini-css-extract-plugin
module.exports = {"root":"TagBlock_root__HapuE"};